// src/lib/slug.mjs
// Трансліт UA → Latin. Правила компактні та стабільні для URL.
export function ukrainianToLatin(input = '') {
  const map = {
    А:'A', Б:'B', В:'V', Г:'H', Ґ:'G', Д:'D', Е:'E', Є:'Ye', Ж:'Zh', З:'Z',
    И:'Y', І:'I', Ї:'Yi', Й:'Y', К:'K', Л:'L', М:'M', Н:'N', О:'O', П:'P',
    Р:'R', С:'S', Т:'T', У:'U', Ф:'F', Х:'Kh', Ц:'Ts', Ч:'Ch', Ш:'Sh', Щ:'Shch',
    Ь:'', Ю:'Yu', Я:'Ya',
    а:'a', б:'b', в:'v', г:'h', ґ:'g', д:'d', е:'e', є:'ie', ж:'zh', з:'z',
    и:'y', і:'i', ї:'i', й:'i', к:'k', л:'l', м:'m', н:'n', о:'o', п:'p',
    р:'r', с:'s', т:'t', у:'u', ф:'f', х:'kh', ц:'ts', ч:'ch', ш:'sh', щ:'shch',
    ь:'', ю:'iu', я:'ia',
  };
  return Array.from(input)
    .map(ch => map[ch] ?? ch)
    .join('');
}

// Нормалізація до формату slug: лише латиниця, цифри, дефіси/підкреслення.
export function toSlugBase(str = '') {
  return ukrainianToLatin(str)
    .replace(/\s+/g, '_')       // пробіли → "_"
    .replace(/[^A-Za-z0-9\-_]/g, '') // прибрати зайве
}

// Викладач: додаємо індекс-суфікс для унікальності: Surname_II-07
export function buildTeacherSlug(fullName, index) {
  const base = toSlugBase(fullName);
  const id = String(index).padStart(2, '0');
  return `${base}-${id}`;
}

// Група: лише трансліт, зберігаємо дефіси та великі літери (A-12)
export function buildGroupSlug(groupName) {
  // Літери транслітимо, дефіси/цифри лишаємо, пробіли → "_"
  const base = toSlugBase(groupName).toUpperCase();
  return base;
}

// Парсінг teacher slug → { base, index }
export function parseTeacherSlug(slug = '') {
  const m = slug.match(/^(.*)-(\d{1,3})$/);
  if (!m) return { base: slug, index: null };
  return { base: m[1], index: Number(m[2]) };
}
